"use client"

import React, { useState, useEffect } from "react";
import { useConfig } from "@/lib/providers/ConfigProvider";
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import moment from "moment";
import { useMediaQuery } from "react-responsive";

import "@/components/shared/EventCalendarLink.css";

const EventCalendarLink = ({
  event
}) => {
  const { webUrl } = useConfig();
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });
  const [eventLinkInfo, setEventLinkInfo] = useState(null);

  useEffect(() => {
    if (event) {
      let eventUrl = `${webUrl}${event.owner.resourceName}/events/${event.id}`;
      if (event.eventType === "PROJECT") {
        eventUrl = `${webUrl}${event.owner.resourceName}/portal#projects/${event.id}`;
      }
      const startDate = moment(event.startDate.date);
      const endDate = event.endDate ? moment(event.endDate.date) : null;

      setEventLinkInfo({
        title: event.title,
        description: event.description,
        eventUrl: eventUrl,
        startDate: startDate.format("YYYY-MM-DD"),
        startTime: startDate.format("HH:mm"),
        endDate: endDate ? endDate.format("YYYY-MM-DD") : startDate.format("YYYY-MM-DD"),
        endTime: endDate ? endDate.format("HH:mm") : null,
        location: event.location != null ? event.location.name : null,
      });
    }
  }, [event]);

  if (!eventLinkInfo) return null;

  return (
    <AddToCalendarButton
      className="add-to-calendar"
      name={eventLinkInfo.title}
      description={`${eventLinkInfo.description}[br][br][url]${eventLinkInfo.eventUrl}|View Event[/url]`}
      startDate={eventLinkInfo.startDate}       // "YYYY-MM-DD"
      startTime={eventLinkInfo.startTime}       // "HH:mm"
      endDate={eventLinkInfo.endDate}           // "YYYY-MM-DD"
      endTime={eventLinkInfo.endTime}           // "HH:mm"
      location={eventLinkInfo.location || ""}
      timeZone="currentBrowser"
      options={['Apple', 'Google', 'Yahoo', 'Outlook.com']}
      buttonStyle="round"        // "default", "flat", "round", "neumorphism", "text", "date", "custom"
  listStyle={isSm ? "modal" : "dropdown"}      // "dropdown", "dropup", "modal", "overlay"
  lightMode="light"          // "light", "dark", "system", "bodyScheme"
  // pastDateHandling="hide"
  hideIconButton={true}
  hideCheckmark={true}
  trigger={isSm ? "click" : "hover"}
    />
  );
};

export default EventCalendarLink;